import { render, staticRenderFns } from "./MainNavToggle.vue?vue&type=template&id=a47190c6&"
import script from "./MainNavToggle.vue?vue&type=script&lang=js&"
export * from "./MainNavToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports